<template functional>
  <span
    :aria-hidden="props.decorative"
    :aria-label="props.title"
    :class="[data.class, data.staticClass]"
    v-bind="data.attrs"
    class="material-design-icon access-point-off-icon"
    role="img"
    v-on="listeners">
    <svg
      :fill="props.fillColor"
      :width="props.size"
      :height="props.size"
      class="material-design-icon__svg"
      viewBox="0 0 24 24">
      <path 
        fill-rule="evenodd" 
        d="M17 7v3.5l4-4v11l-4-4V17c0 .55-.45 1-1 1H4c-.55 0-1-.45-1-1V7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1zM9 9H7v6h2V9zm4 0h-2v6h2V9z" 
        clip-rule="evenodd"/>
    </svg>
  </span>
</template>

<script>
export default {
  name: "NoVideo",
  props: {
    title: {
      type: String,
      default: "No Video icon"
    },
    decorative: {
      type: Boolean,
      default: false
    },
    fillColor: {
      type: String,
      default: "currentColor"
    },
    size: {
      type: Number,
      default: 24
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/icons/NoVideo.vue